import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiControlDirective } from '../../../directives/ui/ui-control.directive';
import { LAYOUT_SERVICE_TOKEN } from '@aksia/infrastructure';

@Component({
  selector: 'page-bookmark',
  imports: [RouterModule],
  templateUrl: './page-bookmark.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageBookmarkComponent extends UiControlDirective {
  //#region Injections

  protected readonly layout = inject(LAYOUT_SERVICE_TOKEN);

  //#endregion

  //#region Host Bindings

  @HostBinding('attr.uipagebookmark') uipagebookmark = '';

  //#endregion
}
